import React, { forwardRef } from 'react';
import * as DialogBox from '@radix-ui/react-dialog';
import CloseIcon from '~/icons/close.svg';
import styles from './Dialog.module.scss';

export type DialogContentProps = DialogBox.DialogContentProps & {
    /** When true, dialog can only be closed via an explicit action inside (e.g. a button). Hides close (X), disables Esc and click-outside. */
    preventDismiss?: boolean;
};

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
    ({ children, preventDismiss = false, ...props }, forwardedRef) => (
        <DialogBox.Portal>
            <DialogBox.Overlay className={styles.dialogOverlay} />
            <DialogBox.Content
                className={styles.dialogContent}
                onEscapeKeyDown={preventDismiss ? (e) => e.preventDefault() : undefined}
                onPointerDownOutside={preventDismiss ? (e) => e.preventDefault() : undefined}
                {...props}
                ref={forwardedRef}
            >
                {!preventDismiss && (
                    <div className={styles.dialogHeader}>
                        <DialogBox.Close asChild tabIndex={0}>
                            <button className={styles.dialogClose} type="submit">
                                <CloseIcon />
                            </button>
                        </DialogBox.Close>
                    </div>
                )}
                <DialogBox.Title />
                {children}
            </DialogBox.Content>
        </DialogBox.Portal>
    ),
);

DialogContent.displayName = 'DialogContent';
export const Dialog = DialogBox.Root;
export const DialogTrigger = DialogBox.Trigger;
